import React from 'react';
import { createIcon } from './create-icon';
import './icon-check-filled.scss';

export const IconCheckFilled = createIcon(<div className="icon-check-filled" />);
